<template>
  <div>
    <h2>Hier können Sie Ihr Passwort ändern</h2>
Bitte geben Sie Ihr neues Passwort aus Sicherheitsgründen zweimal ein.
    <br />
    <br />
    <v-form ref="form" v-model="valid" @submit.prevent="updatePassword">
      <v-text-field
        v-model="userPassword.password"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        label="Neues Passwort"
        @click:append="showPassword = !showPassword"
        required
      ></v-text-field>
      <v-text-field
        v-model="userPassword.password_confirm"
        :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPasswordConfirm ? 'text' : 'password'"
        :error-messages="passwordError"
        label="Passwort bestätigen"
        @click:append="showPasswordConfirm = !showPasswordConfirm"
        @blur="validatePasswordMatch"
        required
      ></v-text-field>
      <v-btn
        type="submit"
        color="primary"
        :disabled="!isPasswordValid"
      >
        Passwort ändern
      </v-btn>
    </v-form>
  </div>
</template>

<script setup>
import { ref, computed, watch, inject } from "vue";


const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore')
const errorStore = inject('errorStore');
const successStore = inject('successStore');




const valid = ref(false);

const userPassword = ref({
  password: '',
  password_confirm: '',
  action: 'updatepassword'
});

const passwordError = ref('');
const showPassword = ref(false);
const showPasswordConfirm = ref(false);

function validatePasswordMatch() {
  if (!userPassword.value.password_confirm) {
    passwordError.value = 'Bitte bestätigen Sie Ihr Passwort';
    return false;
  }
  
  if (userPassword.value.password !== userPassword.value.password_confirm) {
    passwordError.value = 'Die Passwörter stimmen nicht überein';
    return false;
  }
  
  passwordError.value = '';
  return true;
}

watch(() => userPassword.value.password, () => {
  if (userPassword.value.password_confirm) {
    validatePasswordMatch();
  }
});

watch(() => userPassword.value.password_confirm, (newValue) => {
  if (newValue && userPassword.value.password === newValue) {
    passwordError.value = '';
  }
});

const isPasswordValid = computed(() => {
  return userPassword.value.password && 
         userPassword.value.password_confirm && 
         userPassword.value.password === userPassword.value.password_confirm;
});

async function updatePassword() {
  if (!validatePasswordMatch()) {
    errorStore.setError('Die Passwörter stimmen nicht überein');
    return;
  }
  
  loaderStore.setLoader(true, "Passwort wird aktualisiert...");
  
  try {
    const response = await baseCalls.userPost(userPassword.value);
    
    if (response.data && response.data.success) {
      successStore.setSuccess(
        true,
        "Passwort geändert",
        "Ihr Passwort wurde erfolgreich aktualisiert"
      );
      
      userPassword.value.password = '';
      userPassword.value.password_confirm = '';
    } else {
      throw new Error(response.data.message || "Fehler beim Aktualisieren des Passworts");
    }
  } catch (err) {
    errorStore.setError(
      err.message || "Beim Ändern des Passworts ist ein Fehler aufgetreten"
    );
    console.error("Fehler beim Passwort-Update:", err);
  } finally {
    loaderStore.setLoader(false);
  }
}
</script>